ModalView = require 'views/modal'


module.exports = class HintModalView extends ModalView
    __name__: 'HintModalView'
    template: require 'views/templates/hint-modal'
